import { Component, OnInit } from '@angular/core';
import { AppMainComponent } from '../../../app.main.component';
import { ConfirmationService, LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { AccountUserService } from '../../../service/account.service';
import { MyDocumentsService } from '../../my-documents';
import { ProfileService } from '../../profileService';
import * as JSZip from 'jszip';
import * as FileSaver from 'file-saver';
import { AppMainService } from 'src/app/app-main.service';
import { FileInfo, IWarningFileFolderResponse, NewFileFolder, WarningFileFolder } from 'src/app/models/NewFileFolder';
import { uploadFiles, validateFiles } from 'src/app/shared/upload-files';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { DocumentViewerService } from 'src/app/modules/shared/services/document-viewer.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Severity } from 'src/app/inventory/constants/constants';
import { TitleCasePipe } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {
  MAX_SIZE = 26314400;
  user;
  configMenuDocument;
  selectedDocumentWindow = 'files';
  menuItemsFiles;
  itemsHeader: MenuItem[];
  homeHeader: MenuItem;
  homeRecentHeader: MenuItem;
  homeSharedHeader: MenuItem;
  homeDownloadHeader: MenuItem;
  allFiles = [];
  filesData = [];
  recentData = [];
  sharedData = [];
  filesDataVm = [];
  tabindex = 1;

  allFilesFolder = [];
  allFilesFolderVm = [];
  sharedFilesAndFolders = [];
  downloadsFilesAndFolder = [];
  parentFolderId = 0;
  currentFolderId = 0;
  searchValue: string = '';
  selectedSection: string = 'files';
  zipData;

  displayNewFile = false;
  uploadedFiles: any[] = [];

  newFileFolder: NewFileFolder = new NewFileFolder();
  allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.txt', '.xls', '.xlsx', 'csv', '.doc', '.docx', '.ppt', '.pptx', 'pdf'];
  files = [];

  moduleSearchValue = '';
  pageNumber: number = 1;
  pageSize: number = 15;
  isLoading: boolean = true;
  first: number = 0;
  totalRecords: number = 0;
  tableShowMore: number[] = [15, 30, 50, 100];

  filesFolderDataText = 'Loading...';
  tooltipText = '';
  uploadFilePath = 'Files';

  modalHeader: string;
  isUpload: boolean;
  uploadedFilesCount = 0;
  totalFileSize = 0;

  displayFilePreview: boolean = false;
  currentFile: any;
  displayShareAssign = false;
  tempShare;
  allReadCheck: boolean = false;
  allWriteCheck: boolean = false;
  allDownLoadCheck: boolean = false;
  permissionList: any = [];
  fileData: any;
  updatedpermissionList: any = [];
  documentUserSearchText: string;
  userQuestionUpdate = new Subject<string>();
  oldPermisssionList: any = [];
  maxFilesizeErrorMessage = [];
  maxNoOfFilesErrorMessage = [];
  newFileList: File[] = [];
  showDocumentVersionsDialog: boolean = false;
  documentVersionsLists: [] = [];
  totalRecordsShare:number = 0;
  pageNumberShare:number = 1;
  constructor(
    public app: AppMainComponent,
    private messageService: MessageService,
    private accountUserService: AccountUserService,
    private documentService: MyDocumentsService,
    private profileService: ProfileService,
    private appMainService: AppMainService,
    public confirmationService: ConfirmationService,
    private documentViewerService: DocumentViewerService,
    private titlecasePipe: TitleCasePipe
  ) {
    this.accountUserService.user.subscribe(x => this.user = x);
    this.userQuestionUpdate.pipe(
      debounceTime(5000),
      distinctUntilChanged())
      .subscribe(value => {
        // this.openShare(this.fileData, value)
      });
  }

  ngOnInit(): void {
    this.buildDocumentMenu();
    this.buildFilesUploadMenuItems();
    // this.getDummyFilesData();
    this.setModuleSearchValue();
    this.getAllFilesAndFolderLite(0);
    // this.getAllFilesAndFolder(this.parentFolderId);
    //this.downloadFileFromAFolder(11791);

    this.homeHeader = {
      label: 'Files',
      //command: (event) => this.clearFile(),
    };
    this.homeRecentHeader = {
      label: 'Recent',
      //command: (event) => this.clearFile(),
    };
    this.homeSharedHeader = {
      label: 'Shared',
      //command: (event) => this.clearFile(),
    };
    this.homeDownloadHeader = {
      label: 'Downloads',
      //command: (event) => this.clearFile(),
    };
  }

  setModuleSearchValue() {
    switch (this.selectedDocumentWindow) {
      case 'files': {
        this.moduleSearchValue = 'MyDocument';
        break;
      }
      case 'download': {
        this.moduleSearchValue = 'Download';
        break;
      }
      case 'shared': {
        this.moduleSearchValue = 'Shared';
        break;
      }
      default: {
        this.moduleSearchValue = '';
        break;
      }
    }
  }

  buildDocumentMenu(): void {
    let files = this.selectedDocumentWindow == 'files' ? '<span class="selectedConfigMenuItem">Files</span>' : 'Files';
    let shared = this.selectedDocumentWindow == 'shared' ? '<span class="selectedConfigMenuItem">Shared</span>' : 'Shared';
    let download = this.selectedDocumentWindow == 'download' ? '<span class="selectedConfigMenuItem">Downloads</span>' : 'Downloads';

    this.configMenuDocument = [
      {
        label: files,
        escape: false,
        command: () => {
          this.selectedDocumentWindow = 'files';
          this.parentFolderId = this.currentFolderId = 0;
          this.resetWindowValue('files');
          this.buildDocumentMenu();
        },
      },
      // {
      //   label: recent,
      //   escape: false,
      //   command: () => {
      //     this.selectedDocumentWindow = 'recent';
      //     this.buildDocumentMenu();
      //     this.itemsHeader = null;
      //   },
      // },

      {
        label: download,
        escape: false,
        command: () => {
          this.selectedDocumentWindow = 'download';
          this.resetWindowValue('download');
          this.buildDocumentMenu();
        },
      },
      {
        label: shared,
        escape: false,
        command: () => {
          this.selectedDocumentWindow = 'shared';
          this.itemsHeader = null;
          this.resetWindowValue('shared');
          this.buildDocumentMenu();
        },
      },
    ];
  }

  resetWindowValue(selectedWindow: string): void {
    this.selectedDocumentWindow = selectedWindow;
    this.itemsHeader = null;
    this.setModuleSearchValue();
    this.pageNumber = 1;
    this.pageSize = 15;
    this.first = 0;
    this.totalRecords = 0;
    if(selectedWindow=='shared'){
        this.getSharedFilesAndFolder();
    }else{
        this.getAllFilesAndFolderLite(0);
    }
  }

  buildFilesUploadMenuItems(): void {
    this.menuItemsFiles = [
      {
        label: 'Add New Folder',
        icon: 'pi pi-plus',
        command: () => {
          this.openNewFileModal();
          this.isUpload = false;
          this.modalHeader = 'Add New Folder';
        }
      },
      {
        label: 'Upload',
        icon: 'pi pi-upload',
        command: () => {
          this.openNewFileModal();
          this.isUpload = true;
          this.modalHeader = 'Upload Files';
          this.setUploadFilePath();
        }
      }
    ];
  }

  openNewFileModal() {
    this.displayNewFile = true;
    this.tooltipText =
      `
    Notes:
    1. Allowed file extensions: ${this.allowedExtensions.join(', ')}.
    2. Maximum upload size for a single file is 10MB.
    3. Maximum upload size is 25MB.
    4. Maximum 3 files can be uploaded.
    `;
  }

  getDummyFilesData(): void {
    this.profileService.getAllFiles().then(f => {
      this.allFiles = f;
      this.filesData = JSON.parse(JSON.stringify(this.allFiles));
      this.filesDataVm = JSON.parse(JSON.stringify(this.allFiles));
      // this.recentData = this.filesData.filter(ele => ele.)
      this.sharedData = this.filesData.filter(ele => ele.type == 'Shared')
    }).catch((error)=>{
      // console.log(error);
    });
  }

  openSharedFolder(data) {
    // this.parentFolderId = data?.parentFolderId;
    this.currentFolderId = data?.id;
    this.setModuleSearchValue();
    this.getSharedFilesAndFolder(data?.id);
    // this.openFolder(data);
    // this.getSharedFilesAndFolder(data?.id);
    if (data?.isFolder && this.itemsHeader == null) {
      this.itemsHeader = [
        {
          label: data.name,
          id: data.id,
          command: () => {
            //this.removeFile(data);
          }
        }
      ];
      //this.filesData = JSON.parse(JSON.stringify(data.children));
      var childForFiles = [];
      var childForFolders = [];

      var combinedFilesAndFolders = [];

      if (data.childFiles?.length > 0) {
        childForFiles = data.childFiles.map(obj => ({ ...obj }));

        for (let i = 0; i < childForFiles.length; i++) {
          combinedFilesAndFolders.push(childForFiles[i]);
        }

      }
      if (data.childFolders?.length > 0) {

        childForFolders = data.childFolders.map(obj => ({ ...obj }));
        for (let i = 0; i < childForFolders.length; i++) {
          combinedFilesAndFolders.push(childForFolders[i]);
        }

      }

      this.allFilesFolder = JSON.parse(JSON.stringify(combinedFilesAndFolders));

    }
    else if (data?.isFolder && this.itemsHeader != null) {
      let items = JSON.parse(JSON.stringify(this.itemsHeader));
      let obj = {
        label: data.name,
        id: data.id,
        command: () => {
          this.removeFile(data);
        }
      }
      items.push(obj);
      this.itemsHeader = JSON.parse(JSON.stringify(items));
      //this.filesData = JSON.parse(JSON.stringify(data.children));
      var childForFiles = [];
      var childForFolders = [];

      var combinedFilesAndFolders = [];

      if (data.childFiles?.length > 0) {
        childForFiles = data.childFiles.map(obj => ({ ...obj }));

        for (let i = 0; i < childForFiles.length; i++) {
          combinedFilesAndFolders.push(childForFiles[i]);
        }


      }
      if (data.childFolders?.length > 0) {

        childForFolders = data.childFolders.map(obj => ({ ...obj }));
        for (let i = 0; i < childForFolders.length; i++) {
          combinedFilesAndFolders.push(childForFolders[i]);
        }

      }
      this.allFilesFolder = JSON.parse(JSON.stringify(combinedFilesAndFolders));
    }
  }



  openFolder(data) {
    this.parentFolderId = data.parentFolderId;
    this.currentFolderId = data.id;
    this.setModuleSearchValue();
    this.getAllFilesAndFolderLite(data.id);
    if (data?.isFolder && this.itemsHeader == null) {
      this.itemsHeader = [
        {
          label: data.name,
          id: data.id,
          command: () => {
            //this.removeFile(data);
          }
        }
      ];
      //this.filesData = JSON.parse(JSON.stringify(data.children));
      var childForFiles = [];
      var childForFolders = [];

      var combinedFilesAndFolders = [];

      if (data.childFiles?.length > 0) {
        childForFiles = data.childFiles.map(obj => ({ ...obj }));

        for (let i = 0; i < childForFiles.length; i++) {
          combinedFilesAndFolders.push(childForFiles[i]);
        }

      }
      if (data.childFolders?.length > 0) {

        childForFolders = data.childFolders.map(obj => ({ ...obj }));
        for (let i = 0; i < childForFolders.length; i++) {
          combinedFilesAndFolders.push(childForFolders[i]);
        }

      }

      this.allFilesFolder = JSON.parse(JSON.stringify(combinedFilesAndFolders));

    }
    else if (data?.isFolder && this.itemsHeader != null) {
      let items = JSON.parse(JSON.stringify(this.itemsHeader));
      let obj = {
        label: data.name,
        id: data.id,
        command: () => {
          this.removeFile(data);
        }
      }
      items.push(obj);
      this.itemsHeader = JSON.parse(JSON.stringify(items));
      //this.filesData = JSON.parse(JSON.stringify(data.children));
      var childForFiles = [];
      var childForFolders = [];

      var combinedFilesAndFolders = [];

      if (data.childFiles?.length > 0) {
        childForFiles = data.childFiles.map(obj => ({ ...obj }));

        for (let i = 0; i < childForFiles.length; i++) {
          combinedFilesAndFolders.push(childForFiles[i]);
        }


      }
      if (data.childFolders?.length > 0) {

        childForFolders = data.childFolders.map(obj => ({ ...obj }));
        for (let i = 0; i < childForFolders.length; i++) {
          combinedFilesAndFolders.push(childForFolders[i]);
        }

      }
      this.allFilesFolder = JSON.parse(JSON.stringify(combinedFilesAndFolders));
    }
    // else if (data.group == 'file') {
    //   window.open(data.fileurl, "_blank");
    //   }
  }

  openFileD(data) {
  }

  setUploadFilePath() {
    const length = this.itemsHeader?.length;
    this.uploadFilePath = 'Files';

    if (this.itemsHeader) {
      for (let data of this.itemsHeader) {
        this.uploadFilePath += ` > ${data.label}`;
      }
    }

    this.newFileFolder.name = (!this.itemsHeader || !length) ? 'Files' : this.itemsHeader[length - 1].label;
  }

  openFolderFromBreadcumb(event) {
    const { id, label } = event.item;

    this.setModuleSearchValue();

    if ((this.selectedDocumentWindow === 'files' && label != this.homeHeader.label) ||
      (this.selectedDocumentWindow === 'download' && label != this.homeDownloadHeader.label)) {
      var parentFolder = this.allFilesFolderVm.find(x => x.name == this.itemsHeader[0].label);

      if (parentFolder?.name == label) {
        this.parentFolderId = parentFolder.id;
      } else {
        this.getFolderId(parentFolder, label);
      }

      let index = this.itemsHeader.findIndex(item => item.label == label);
      this.itemsHeader.splice(index + 1);

      this.getAllFilesAndFolderLite(id || this.parentFolderId);

      // this.getAllFilesAndFolderLite(this.parentFolderId);
    }
    else {
      this.parentFolderId = 0;
      this.currentFolderId = 0;
      this.getAllFilesAndFolderLite(0);
      this.itemsHeader = null;
      // this.parentFolderId = 0;
      // this.clearFile();
    }

  }


  openSharedFolderFromBreadcumb(event) {
    const { id, label } = event.item;

    this.setModuleSearchValue();

    if ((this.selectedDocumentWindow === 'shared' && label != this.homeSharedHeader.label)) {
      var parentFolder = this.allFilesFolderVm.find(x => x.name == this.itemsHeader[0].label);

      if (parentFolder?.name == label) {
        this.parentFolderId = parentFolder.id;
      } else {
        this.getFolderId(parentFolder, label);
      }

      let index = this.itemsHeader.findIndex(item => item.label == label);
      this.itemsHeader.splice(index + 1);

      this.getSharedFilesAndFolder(id || this.parentFolderId);

      // this.getAllFilesAndFolderLite(this.parentFolderId);
    }
    else {
      this.parentFolderId = 0;
      this.currentFolderId = 0;
      this.getSharedFilesAndFolder(0);
      this.itemsHeader = null;
      // this.parentFolderId = 0;
      // this.clearFile();
    }

  }

  getFolderId(obj, label) {
    obj?.childFolders.map(obj => {
      if (obj.name != label) {
        this.getFolderId(obj, label);
      }
      else {
        this.parentFolderId = obj.id;
      }
    });
  }

  removeFile(data) {
    // console.log(data)
  }

  clearFile() {
    this.itemsHeader = null;
    //this.getAllFilesAndFolder(0);
    //this.allFilesFolder = JSON.parse(JSON.stringify(this.allFilesFolderVm));
  }

  getAllFilesAndFolder(parentFolderId, fromZip = false) {
    this.filesFolderDataText = 'Loading...';
    this.appMainService.isShowSpinner('files');
    this.documentService.getAllFilesAndFolders(parentFolderId).then((response) => {
      this.allFilesFolder = response;
      this.filesFolderDataText = this.allFilesFolder.length ? '' : 'No records found.';
      //this.updateFilesAndFolderVm();
      ////console.log(this.allFilesFolder);
      this.appMainService.isHideSpinner('files');

      if (fromZip) {
        this.downloadZipFile();
      }
    }).catch((err) => {
      this.filesFolderDataText = 'No records found.';
      const detail = (err.status === 422 || err.status === 500) ? err.error : err.error?.message;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail
      });
      this.appMainService.isHideSpinner('files');
    });
  }

  getAllFilesAndFolderLite(searchValue): void {
    this.isLoading = true;
    this.filesFolderDataText = 'Loading...';
    this.documentService.getAllFilesAndFoldersLite(this.pageNumber, this.pageSize, searchValue, this.moduleSearchValue)
      .then((response:any) => {
        let { headers, files } = response;
        headers = headers || [];
        this.totalRecords = headers['TotalCount'];
        this.allFilesFolder = files || [];
        this.filesFolderDataText = this.allFilesFolder.length ? '' : 'No records found.';
        this.isLoading = false;
        this.parentFolderId = response?.files[0]?.parentFolderId;
      })
      .catch((err) => {
        this.allFilesFolder = [];
        this.filesFolderDataText = 'No records found.';
        const detail = err.status === 422 ? err.error : (err.error?.message ? err.error?.message : err.error?.Message);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail
        });
        this.isLoading = false;
      });
  }

  getFilesWithPagination(event): void {
    this.pageNumber = event.page + 1;
    this.pageSize = event.rows;

    switch (this.selectedDocumentWindow) {
      case 'files':
        this.getAllFilesAndFolderLite(this.currentFolderId);
        break;
      case 'shared':
        this.getSharedFilesAndFolder(this.currentFolderId);
        break;
      case 'download':
        this.getAllFilesAndFolderLite(this.currentFolderId);
        break;
    }
  }

  refreshListing() {
    this.searchValue = '';
    switch (this.selectedDocumentWindow) {
      case 'files':
        this.getAllFilesAndFolderLite(this.parentFolderId);
        break;
      case 'download':
        this.refreshDownloadSection();
        break;
      case 'shared':
        this.getSharedFilesAndFolder();
        break;
    }
  }

  refreshDownloadSection() {
    this.getAllFilesAndFolderLite(this.currentFolderId);
  }

  refreshSharedSection() {
    this.getAllFilesAndFolderLite(this.currentFolderId);
  }

  updateFilesAndFolderVm() {
    this.documentService.getAllFilesAndFolders(0).then((response) => {
      this.allFilesFolderVm = response;
    });
  }

  // updateFilesAndFolderVmLite() {
  //   this.setModuleSearchValue();
  //   this.documentService.getAllFilesAndFoldersLite(0, this.filterValue).then((response) => {
  //     this.allFilesFolderVm = response;
  //   });
  // }

  getSharedFilesAndFolder(parentFolderId?: number) {
    this.isLoading = true;
    this.filesFolderDataText = 'Loading...';
    let requestBody: {
      parentFolderId: number,
      pageSize: number,
      pageNumber: number
    } = {
      parentFolderId: parentFolderId ? parentFolderId : 0,
      pageSize: this.pageSize,
      pageNumber: this.pageNumber
    }
    this.parentFolderId = requestBody.parentFolderId;
    this.documentService.getSharedFileOrFolders(requestBody).subscribe({
      next: (data: any) => {
        let pagination = JSON.parse(data.headers.get('X-Pagination'));
        if (pagination) {
          this.totalRecords = pagination?.TotalCount;
        }
        this.sharedFilesAndFolders = data.body || [];
        this.isLoading = false;
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getDocumentUserList');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    });
  }

  // downloadFileFromAFolder(folderId : number){
  //     this.documentService.getDownloadedFilesFromFolder(folderId).then((response) => {
  //       //console.log(response);
  //     })
  // }

  /*** Previous Implementation ***/
  // downloadAsZip(data) {
  //   this.documentService.downloadCount(data.id).then((response) => {
  //     // if (response){

  //     // }
  //   })

  //   const zip = new JSZip();
  //   const zipName = data.name + '.zip';
  //   this.generateFilesAndFolder(zip, data);

  //   zip.generateAsync({type:"blob"}).then(function(content) {
  //     FileSaver.saveAs(content, zipName);
  //   });
  // }

  /*** Newer Implementation ***/

  downloadAsZip(data) {
    this.getAllFilesAndFolder(data.parentFolderId, true);
    this.zipData = data;
  }

  downloadZipFile() {
    const fileData = this.allFilesFolder.find(el => el.id === this.zipData.id);
    this.documentService.downloadCount(fileData.id);

    const zip = new JSZip();
    const zipName = fileData.name + '.zip';

    this.appMainService.isShowSpinner('generateFilesAndFolder');

    this.generateFilesAndFolder(zip, fileData);

    zip.generateAsync({ type: "blob" })
      .then(content => {
        FileSaver.saveAs(content, zipName);
        this.getAllFilesAndFolderLite(fileData.parentFolderId);
      });
    this.appMainService.isHideSpinner('generateFilesAndFolder');
  }

  // findChildFiles(data: any){
  //   var childForFiles = [];
  //   var AllFiles = [];

  //   childForFiles = data.childFiles.map(obj => ({...obj}));

  //   for (let i = 0; i < childForFiles.length; i++) {
  //       AllFiles.push(childForFiles[i]);
  //   }


  //   ////console.log(AllFiles);
  //   return AllFiles;

  // }

  // generateFilesAndFolder(data) {
  //     var folderName = data.name;
  //     if (data.childFiles.length > 0){
  //       var childForFiles = [];
  //       var childForFolders = [];
  //       var filesContent = [];
  //       childForFiles = data.childFiles.map(obj => ({...obj}));

  //         for (let i = 0; i < childForFiles.length; i++){
  //           filesContent.push(childForFiles[i]);
  //         }
  //     }
  //     if (data.childFolders.length > 0){
  //           childForFolders = data.childFolders.map(obj => ({...obj}));
  //           var hasChildFolder = true;
  //     }
  //     else {
  //         hasChildFolder = false;
  //     }

  //   return [filesContent, folderName, hasChildFolder, childForFolders];
  // }


  async generateFilesAndFolder(root, data) {


    data?.childFiles?.map(async childFiles => {
      /// Download through blob start

      // const file = await fetch(childFiles.downloadLink);
      // ////console.log(file);
      // const fileData = await file.blob();
      // root.file(`${childFiles.name}.${childFiles.extension}`,
      // fileData);

      /// Download through blob start

      /// Normal Start

      root.file(`${childFiles.name}.${childFiles.extension}`,
        `${childFiles.content}`, { base64: true });

      /// Normal End

      /// Direct with filesaver start

      //var file = FileSaver.saveAs(`${childFiles.downloadLink}`);
      // root.file(`${childFiles.name}.${childFiles.extension}`,
      // FileSaver.saveAs(`${childFiles.downloadLink}`));

      /// Direct with filesaver end
    })

    data.childFolders?.map(obj => {
      let folder = root.folder(obj.name);
      this.generateFilesAndFolder(folder, obj);
    });
  }

  downloadSingleFile(data) {
    // this.documentService.downloadCount(data.id);
    // setTimeout(() => {
    //   this.getAllFilesAndFolderLite(data.parentFolderId);
    // }, 200);
    // window.open(data.downloadLink, "_self");
    this.appMainService.isShowSpinner('downloadSingleFile');
    let requestBody: {
      id: number;
      isDefaultContentType: boolean
    } = {
      id: data?.id,
      isDefaultContentType: true
    }
    this.documentService.downloadFilesAndFolder(requestBody).subscribe({
      next: (result) => {
        // console.log(result);
        this.UpdateDownloadCount(result?.attachmentId);
        this.downloadedFile(result?.downloadLink);
        this.appMainService.isHideSpinner('downloadSingleFile');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('downloadSingleFile');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    })
  }


  UpdateDownloadCount(id: number) {
    this.appMainService.isShowSpinner('UpdateDownloadCount');
    this.documentService.UpdateDownloadCount(id).subscribe({
      next: (result) => {
        this.getAllFilesAndFolderLite(this.currentFolderId);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document is succesfully downloaded.'
        });
        this.appMainService.isHideSpinner('UpdateDownloadCount');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('UpdateDownloadCount');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    })
  }

  downloadedFile(url: string) {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    // the filename you want
    a.download = 'todo-1.json';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  }

  DeleteFile(id, name, parentFolderId) {
    this.confirmationService.confirm({
      message: `Do you want to delete <b>${name}</b>?`,
      header: 'Delete Confirmation',
      key: 'fileDelete',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('DeleteFile');
        this.documentService.deleteFileOrFolder(id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Sucessfully...' });
          this.setModuleSearchValue();
          this.getAllFilesAndFolderLite(parentFolderId);
          this.appMainService.isHideSpinner('DeleteFile');
        }).catch((err) => {
          if (err) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting this...' });
            this.appMainService.isHideSpinner('DeleteFile');
          }
        });
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  deleteSharedFile(id: number, name: string, parentFolderId: number) {
        this.confirmationService.confirm({
            message: `Do you want to delete <b>${name}</b>?`,
            header: 'Delete Confirmation',
            key: 'fileDelete',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.appMainService.isShowSpinner('DeleteFile');
                this.documentService.deleteSharedFileOrFolder(id)
                    .then(() => {
                        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Successfully...' });
                        this.refreshListing();
                    })
                    .catch((err) => {
                        console.error('Error while deleting:', err);
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting this...' });
                    })
                    .finally(() => {
                        this.appMainService.isHideSpinner('DeleteFile');
                    });
            },
            reject: () => {
                this.confirmationService.close();
            }
        });
    }


  DeleteFolder(id, name, parentFolderId) {

    this.confirmationService.confirm({
      message: `Do you want to delete <b>${name}</b>?`,
      header: 'Delete Confirmation',
      key: 'folderDelete',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('DeleteFolder');
        this.documentService.deleteFileOrFolder(id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Sucessfully...' });
          this.setModuleSearchValue();
          this.getAllFilesAndFolderLite(parentFolderId);
          this.appMainService.isHideSpinner('DeleteFolder');
        }).catch((err) => {
          if (err) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting this...' });
            this.appMainService.isHideSpinner('DeleteFolder');
          }
        });
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  deleteSharedFolder(id, name, parentFolderId) {
    this.confirmationService.confirm({
      message: `Do you want to delete <b>${name}</b>?`,
      header: 'Delete Confirmation',
      key: 'folderDelete',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('DeleteFolder');
        this.documentService.deleteSharedFileOrFolder(id).then(() => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted Sucessfully...' });
          this.refreshListing();
          this.appMainService.isHideSpinner('DeleteFolder');
        }).catch((err) => {
          if (err) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while deleting this...' });
            this.appMainService.isHideSpinner('DeleteFolder');
          }
        });
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  // onUpload(event) {
  //   for (let file of event.files) {
  //     this.uploadedFiles.push(file);
  //   }

  //   this.messageService.add({ severity: 'info', summary: 'File Uploaded', detail: '' });
  // }

  setFormData(data: NewFileFolder): any {
    const formData = new FormData();

    formData.append('name', this.isUpload ? '' : data.name.trim());
    formData.append('parentFolderId', this.currentFolderId.toString());
    formData.append('isFolderReplacable', data?.isFolderReplacable?.toString() ?? 'false');
    let fileInfo: FileInfo[] = [];
    for (let file of data.childFiles) {
      formData.append('childFiles', file);
    }
    formData.append('fileOtherInfoJsonList', JSON.stringify(data.fileOtherInfoJsonList) ?? '[]');
    return formData;
  }

  getFileWarning(data: NewFileFolder): WarningFileFolder {
    const warningFileFolder: WarningFileFolder = new WarningFileFolder();
    warningFileFolder.folderName = this.isUpload ? null : data.name.trim();
    warningFileFolder.parentFolderId = this.currentFolderId;
    // warningFileFolder.parentFolderId = 10021282;
    // for (let file of data.childFiles) {
    //   const fileName = file.name;
    //   let name = "";
    //   let extension = "";
    //   if (fileName) {
    //     if (fileName.indexOf(".") !== -1) {
    //       extension = fileName.split(".").pop();
    //       // name = fileName;
    //       name = fileName.slice(0, fileName.lastIndexOf('.'))
    //     }
    //     else {
    //       name = fileName;
    //     }
    //   }
    //   warningFileFolder.fileInfos.push({ name: name, replacedName: name, extension: extension, size: file.size, isFileReplacable: false });
    // }
    warningFileFolder.fileInfos = data.fileOtherInfoJsonList;
    return warningFileFolder;
  }

  createUpdateFolderFilesWaringg() {
    if (this.totalFileSize > this.MAX_SIZE) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Maximum Upload Size Limit Exceeded',
        detail: 'Maximum upload size is 25MB!'
      });
      return;
    }

    this.appMainService.isShowSpinner('createNewFile');
    const warningFileFolder = this.getFileWarning(this.newFileFolder)
    if (warningFileFolder.fileInfos.some(x => x.isFileReplacable == false)
      && warningFileFolder.fileInfos.some(x => x.fileWarningCheck == false)) {
      this.documentService.getNewFileWaring(warningFileFolder)
        .toPromise()
        .then((res: IWarningFileFolderResponse[]) => {
          if (res?.length > 0) {
            this.appMainService.isHideSpinner('createNewFile');
            res.forEach(doc => {
              let existingDoc = this.newFileFolder.childFiles.find(x => x.name == doc.name + "." + doc.extension);
              let existingDocJson = this.newFileFolder.fileOtherInfoJsonList.find(x => x.name + "." + x.extension == doc.name + "." + doc.extension);
              if (existingDoc && existingDocJson) {
                existingDocJson.fileExist = true;
              }
            });
          }
          else {
            this.createUpdateFolderFiles();
          }
          this.newFileFolder.fileOtherInfoJsonList.map(x => { x.fileWarningCheck = true });
        })
        .catch(err => {
          this.appMainService.isHideSpinner('createNewFile');
        });
    }
    else {
      this.createUpdateFolderFiles();
    }
  }

  createUpdateFolderFiles() {
    // this.appMainService.isShowSpinner('createNewFile');
    const formData = this.setFormData(this.newFileFolder);

    this.documentService.createNewFile(formData)
      .toPromise()
      .then(() => {
        this.appMainService.isHideSpinner('createNewFile');
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: this.isUpload ? 'Files uploaded successfully...' : 'Folder created successfully...'
        });
        this.setModuleSearchValue();
        this.getAllFilesAndFolderLite(this.currentFolderId);
        this.setFileDefault();
      })
      .catch(err => {
        this.appMainService.isHideSpinner('createNewFile');

        let detail: string;

        switch (err.status) {
          case 422: {
            detail = err.error;
            break;
          }
          case 500: {
            detail = err.error;
            break;
          }
          case 413: {
            detail = 'The request is larger than the server can handle';
            break;
          }
          case 0: {
            detail = 'The request is larger than the server can handle';
            break;
          }
          default: {
            detail = 'Issue occurred when uploading folder. Please Try after sometime.';
            break;
          }
        }

        if (this.newFileFolder.childFiles.some(file => file?.name?.length > 50)) {
          this.messageService.add({ severity: 'error', summary: 'Filename too long', detail: "Maximum 200 characters filename allowed!" });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail
          });
        }


        this.setFileDefault();
      });
  }

  setJSONFileInfo(data: NewFileFolder) {
    let fileInfo: FileInfo[] = [];
    for (let file of data.childFiles) {
      const fileName = file.name;
      let name = "";
      let extension = "";
      if (fileName) {
        if (fileName.indexOf(".") !== -1) {
          extension = fileName.split(".").pop();
          // name = fileName;
          name = fileName.slice(0, fileName.lastIndexOf('.'))
        }
        else {
          name = fileName;
        }
      }
      fileInfo.push({ name: name, replacedName: name, extension: extension, size: file.size, isFileReplacable: false, fileExist: false, fileWarningCheck: false });
    }
    this.newFileFolder.fileOtherInfoJsonList = fileInfo;
  }

  openFilePreview1(file: any): void {
    // debugger;
    this.displayFilePreview = true;
    this.currentFile = file;
  }

  openFilePreview(product) {
    this.appMainService.isShowSpinner('openFilePreview');
    // console.log(product);
    // const myArray:string[] = product?.name.split(".");
    let docType: string = product?.extension;
    // console.log(docType);
    let requestBody: {
      id: number;
      isDefaultContentType: boolean
    } = {
      id: product?.id,
      isDefaultContentType: false
    }
    this.documentService.downloadFilesAndFolder(requestBody).subscribe({
      next: (data) => {
        // console.log(data);
        switch (docType) {
          case 'docx':
            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
            break;
          case 'xlsx':
            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
            break;
          case 'pptx':
            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
            break;
          case 'csv':
            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
            break;
          case 'pdf':
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
            break;
          case 'jpg':
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
            break;
          case 'png':
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
            break;
          case 'gif':
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
            break;
          case 'txt':
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
            break;
          default:
            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
        }
        this.appMainService.isHideSpinner('openFilePreview');
      },
      error: (error: HttpErrorResponse) => {
        this.appMainService.isHideSpinner('openFilePreview');
        this.messageService.add({
          severity: Severity.Error,
          summary: this.titlecasePipe.transform(Severity.Error),
          detail: "Error occurred while saving data...",
        });
      }
    })
    // this.documentViewerService.selectDocumentType(docType,product?.downloadLink)
  }

  closeFilePreview() {
    this.displayFilePreview = false;
  }

  removeFiles(files: File[], file: File, index: number): File[] {
    files = [...files];
    const { name } = file;
    const seperationIndex = name.lastIndexOf(".");
    const extension = name.substring(seperationIndex);

    if (!this.allowedExtensions.includes(extension)) {
      files.splice(index, 1);
    }

    return files;
  }

  uploadAttachments(files: File[]) {
    this.uploadedFiles = files;
    this.appMainService.isShowSpinner('upload');

    if (typeof Worker !== undefined) {
      for (let file of files) {
        let errors = validateFiles(file, 25, this.allowedExtensions);

        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: error.fileName + ": " + error.error
            });
          }

          this.appMainService.isHideSpinner('upload');
        } else {
          this.newFileList.push(file);
          uploadFiles(file, ({ name, content, size, extension }) => {
            this.totalFileSize += size;
            // this.contactAttachments = {
            //     "id": 0,
            //     "createdSource": this.app.userIP,
            //     "updatedSource": this.app.userIP,
            //     "createdBy": this.app.user.userId,
            //     "updatedBy": this.app.user.userId,
            //     "createdDate": new Date(),
            //     "updatedDate": new Date(),
            //     "contactId": 0,
            //     attachmentId: 0,
            //     attachment: attachment
            // }
            if (this.totalFileSize > 25000000) {
              this.maxFilesizeErrorMessage = [
                { severity: 'error', summary: 'Error', detail: 'Max File size should be less than 25Mb' }
              ];
            } else {
              const foundFile = this.newFileFolder.childFiles.find(childFile => childFile.name === file.name);
              if (!foundFile) {
                this.newFileFolder.childFiles.push(file);
                // this.newFileFolder.childFilesCopy.push(file);
              }
              this.maxFilesizeErrorMessage = [];
            }


            this.appMainService.isHideSpinner('upload');
            this.setJSONFileInfo(this.newFileFolder);
          });
        }
      }
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
    }
    // console.log(this.newFileList.length);
    if (this.newFileList.length > 3) {
      this.maxNoOfFilesErrorMessage = [
        { severity: 'error', summary: 'Error', detail: 'No. of files should be three' }
      ];
    } else {
      this.maxNoOfFilesErrorMessage = []; // Remove the error message
    }
  }

  removeAllFiles() {
    this.newFileFolder.childFiles = [];
    this.totalFileSize = 0;
    this.maxFilesizeErrorMessage = [];
    this.maxNoOfFilesErrorMessage = [];
  }

  getFileIcon(fileName: string): string {
    const seperationIndex = fileName.lastIndexOf(".");
    const extension = fileName.substring(seperationIndex + 1).toLowerCase();
    return `${environment.assestsBasePath}icons/${extension}.png`;
  }



  removeFromUpload(file: File, fileJson: FileInfo, uploader: FileUpload) {
    const index = uploader.files.indexOf(file);
    uploader.remove(null, index);
    if (this.newFileFolder?.fileOtherInfoJsonList?.length > 0) {
      this.newFileFolder.fileOtherInfoJsonList = this.newFileFolder.fileOtherInfoJsonList.filter(x => x != fileJson);
    }
    this.newFileFolder.childFiles = [];
    this.newFileList = [];
    for (let file of uploader.files) {
      this.newFileFolder.childFiles.push(file);
      this.newFileList.push(file);
    }
    this.totalFileSize -= file.size;
    if (uploader.files.length < 4) {
      this.maxNoOfFilesErrorMessage = [];
    }
    if (this.totalFileSize < 25000000) {
      this.maxFilesizeErrorMessage = [];
    }
  }

  setFileDefault() {
    this.newFileFolder = new NewFileFolder();
    this.files = [];
    this.displayNewFile = false;
    this.uploadedFilesCount = 0;
    this.totalFileSize = 0;
    this.maxFilesizeErrorMessage = [];
    this.maxNoOfFilesErrorMessage = [];
    this.newFileList = [];
  }


  openShare(file, search?: string) {
    this.documentUserSearchText = '';
    this.fileData = file;
    this.currentFolderId = file?.id;
    let requestBody: {
      attachmentId: number,
      PageNumber: number,
      PageSize: number,
      ModuleSearchValue?: string,

    } = {
      attachmentId: file?.id,
      PageNumber: this.pageNumber,
      PageSize: this.pageSize,
      ModuleSearchValue: search
    }
    // console.log(requestBody);
    this.appMainService.isShowSpinner('getDocumentUserList');
    this.documentService.getUsersList(requestBody).subscribe({
      next: (data) => {
        let pagination = JSON.parse(data.headers.get('X-Pagination'));
        if (pagination) {
          this.totalRecordsShare = pagination.TotalCount;
        }
        this.displayShareAssign = true;
        this.permissionList = JSON.parse(JSON.stringify(data.body));
        this.oldPermisssionList = JSON.parse(JSON.stringify(data.body));
        // console.log("permissionList",this.permissionList);
        this.appMainService.isHideSpinner('getDocumentUserList');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getDocumentUserList');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    });
  }

  geTUserList(fileId,search){
    let requestBody: {
      attachmentId: number,
      PageNumber: number,
      PageSize: number,
      ModuleSearchValue?: string,

    } = {
      attachmentId: fileId,
      PageNumber: this.pageNumberShare,
      PageSize: this.pageSize,
      ModuleSearchValue: search || ''
    }
    this.appMainService.isShowSpinner('getDocumentUserList');
    this.documentService.getUsersList(requestBody).subscribe({
      next: (data) => {
        let pagination = JSON.parse(data.headers.get('X-Pagination'));
        // this.pageNumber = pagination?.CurrentPage;
        // this.pageSize = pagination?.PageSize;
        this.totalRecordsShare = pagination.TotalCount
        this.displayShareAssign = true;
        this.permissionList = JSON.parse(JSON.stringify(data.body));
        this.oldPermisssionList = JSON.parse(JSON.stringify(data.body));
        this.allReadCheck = false;
        this.allWriteCheck = false;
        this.allDownLoadCheck = false;
        if(this.updatedpermissionList.length > 0){
          this.permissionList.forEach((data) => {
            this.updatedpermissionList.forEach((element) => {
              if(data?.userId == element?.userId){
                data.readable = element.readable;
                data.writable = element.writable;
                data.downloadable = element.downloadable;
              }
            });
          });
        }
        this.appMainService.isHideSpinner('getDocumentUserList');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getDocumentUserList');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    });
  }

  onPageChange(event){
    if (!event) return;
    this.pageSize = event.rows;
    this.pageNumberShare = event.first / event.rows + 1;
    if(this.currentFolderId){
      this.geTUserList(this.currentFolderId,event?.globalFilter);
    }
  }

  checkAll(e,event) {
    if (e == 'Read') {
      this.permissionList.forEach(ele => ele.readable = event.checked);
      this.updateList();
    } else if (e == 'Write') {
      this.permissionList.forEach(ele => ele.writable = event.checked);
      this.updateList();
    } else if (e == 'Download') {
      this.permissionList.forEach(ele => ele.downloadable = event.checked);
      this.updateList();
    }
  }

  updateList(){
    // console.log(this.permissionList);
    // console.log(this.oldPermisssionList);
    // this.oldPermisssionList.forEach(element => {
    //    let found = this.permissionList.find(data => data !== element);
    //    if(found){
    //     this.updatedpermissionList.push(found);
    //    }
    // })
    // console.log(this.updatedpermissionList);
    this.updatedpermissionList = JSON.parse(JSON.stringify(this.permissionList));
  }

  isCheckAll(product) {
    for (let s of this.permissionList) {
      if (s.readable == false) {
        this.allReadCheck = false;
      }
      if (s.writable == false) {
        this.allWriteCheck = false;
      }
      if (s.downloadable == false) {
        this.allDownLoadCheck = false;
      }
    }

    let itemFound = this.oldPermisssionList.find((item) => {
      return item?.userId == product?.userId && (item?.readable != product?.readable || item?.downloadable != product?.downloadable || item?.writable != product?.writable)
    });
    // console.log('itemFound',itemFound);
    // console.log('list',this.updatedpermissionList);
    if (itemFound) {
      // debugger;
      if (this.updatedpermissionList.length == 0) {
        this.updatedpermissionList.push(product);
      } else if (this.notFoundInlist(this.updatedpermissionList, itemFound)) {
        // debugger;
        this.updatedpermissionList.push(product);
      }
      else if (!this.notFoundInlist(this.updatedpermissionList, itemFound)) {
        // debugger;
        this.updatedpermissionList.map((data) => {
          if (data?.userId == itemFound?.userId) {
            data = product;
          }
        })
      }
      // console.log(this.list);
      // console.log(this.notFoundInlist(this.updatedpermissionList, itemFound));
      // debugger;
    } else {
      // item not found
    }
    // console.log(this.updatedpermissionList);
    this.oldPermisssionList = JSON.parse(JSON.stringify(this.permissionList));
  }

  notFoundInlist(list, item): boolean {
    let found = list.find((data) => {
      return data?.userId == item?.userId
    })
    if (found) {
      return false;
    } else {
      return true;
    }
  }

  assignRights() {
    // console.log(this.permissionList);
    this.appMainService.isShowSpinner('assignRights');
    let requestBodydata: {
      userId: number;
      attachmentId: number;
      readable: boolean;
      writable: boolean;
      downloadable: boolean;
    }[] = this.updatedpermissionList.map((data) => {
      let permissionData: {
        userId: number;
        attachmentId: number;
        readable: boolean;
        writable: boolean;
        downloadable: boolean;
      } = {
        userId: data?.userId,
        attachmentId: data?.attachmentId,
        readable: data?.readable,
        writable: data?.writable,
        downloadable: data?.downloadable,
      }
      return permissionData;
    });
    // console.log(requestBodydata);
    this.documentService.updateUserPermission(requestBodydata).subscribe({
      next: (result) => {
        this.displayShareAssign = false;
        this.updatedpermissionList = [];
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          // detail: 'Document share is succesfully updated.'
          detail: 'Document has been shared successfully.'
        });
        this.appMainService.isHideSpinner('assignRights');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('assignRights');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    });
  }

  cancel() {
    this.displayShareAssign = false;
    this.updatedpermissionList = [];
  }

  searchUser() {
    // console.log(this.documentUserSearchText);
  }

  displayNewUpload: boolean = false;
  tempDuc: {
    id: number;
    name: string;
    attachmentCreatedBy: string;
    attachmentCreatedDate: string;
  } = {
      "id": 0,
      "name": "",
      "attachmentCreatedBy": "",
      "attachmentCreatedDate": "",
    };

  editUpload(document) {
    this.displayNewUpload = true;
    this.tempDuc = JSON.parse(JSON.stringify(document));
  }


  editDocument(selectedDocumentWindow: string) {
    this.appMainService.isShowSpinner('editDocument');
    let requestBody: {
      attachmentId: number,
      name: string
    } = {
      attachmentId: this.tempDuc?.id,
      name: this.tempDuc?.name
    }
    this.documentService.sharedDocumentEdit(requestBody).subscribe({
      next: (data) => {
        if (data?.isSuccessful) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Document name is succesfully updated.'
          });
          this.displayNewUpload = false;
          if (selectedDocumentWindow == 'files') {
            this.getAllFilesAndFolderLite(data?.parentFolderId);
          } else {
            this.getSharedFilesAndFolder(this.parentFolderId);
          }
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error!',
            detail: 'Document name is already exist.'
          });
        }
        this.appMainService.isHideSpinner('editDocument');
      },
      error: (error) => {
        this.appMainService.isHideSpinner('editDocument');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    })
  }

  openDocumentVersions(file: any) {
    this.documentVersionsLists = [];
    this.showDocumentVersionsDialog = true;
    this.appMainService.isShowSpinner('openDocumentVersions');
    this.documentService.getAllVersions(file.id).subscribe({
      next: (result) => {
        this.appMainService.isHideSpinner('openDocumentVersions');
        // console.log(result);
        this.documentVersionsLists = result ?? [];
      },
      error: (error) => {
        this.appMainService.isHideSpinner('openDocumentVersions');
        this.messageService.add({
          severity: 'error',
          summary: 'Error!',
          detail: 'Error occurring when loading data. Please try after sometime.'
        });
      },
    })
  }

  openFilePreviewVersion(data: any) {
    this.openFilePreviewLink(data);
  }

  downloadSingleFileVersion(file: any) {
    this.downloadedFile(file?.downloadLink);
  }

  openFilePreviewLink(data: any) {
    switch (data?.extension) {
      case 'docx':
        this.documentViewerService.selectDocumentType(data?.extension, data?.encodedLink);
        break;
      case 'xlsx':
        this.documentViewerService.selectDocumentType(data?.extension, data?.encodedLink);
        break;
      case 'pptx':
        this.documentViewerService.selectDocumentType(data?.extension, data?.encodedLink);
        break;
      case 'csv':
        this.documentViewerService.selectDocumentType(data?.extension, data?.encodedLink);
        break;
      case 'pdf':
        this.documentViewerService.selectDocumentType(data?.extension, data?.downloadLink);
        break;
      case 'jpg':
        this.documentViewerService.selectDocumentType(data?.extension, data?.downloadLink);
        break;
      case 'png':
        this.documentViewerService.selectDocumentType(data?.extension, data?.downloadLink);
        break;
      case 'gif':
        this.documentViewerService.selectDocumentType(data?.extension, data?.downloadLink);
        break;
      case 'txt':
        this.documentViewerService.selectDocumentType(data?.extension, data?.downloadLink);
        break;
      default:
        this.documentViewerService.selectDocumentType(data?.extension, data?.downloadLink);
    }
  }
}
